/**
 * @generated SignedSource<<15d6f9b34c0625df1e50e01768351b72>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type ContentRepresentationV2 = "atlas_doc_format" | "editor" | "editor2" | "export_view" | "plain" | "raw" | "storage" | "styled_view" | "view" | "wiki" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type CommentRendererReadFragment$data = {
  readonly nodes: ReadonlyArray<{
    readonly contentId: string;
    readonly macroId: string;
    readonly renderedMacro: {
      readonly macroBodyStorage: string | null | undefined;
      readonly macroRenderedRepresentation: ContentRepresentationV2 | null | undefined;
      readonly mediaToken: {
        readonly token: string | null | undefined;
      } | null | undefined;
      readonly value: string | null | undefined;
      readonly webResource: {
        readonly contexts: ReadonlyArray<string | null | undefined>;
        readonly keys: ReadonlyArray<string | null | undefined>;
        readonly superbatch: {
          readonly metatags: string | null | undefined;
        } | null | undefined;
        readonly tags: {
          readonly css: string | null | undefined;
          readonly data: string | null | undefined;
          readonly js: string | null | undefined;
        } | null | undefined;
        readonly uris: {
          readonly css: ReadonlyArray<string | null | undefined> | null | undefined;
          readonly data: ReadonlyArray<string | null | undefined> | null | undefined;
          readonly js: ReadonlyArray<string | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly pageInfo: {
    readonly __typename: "PageInfoV2";
    readonly endCursor: string | null | undefined;
    readonly hasNextPage: boolean;
  };
  readonly " $fragmentType": "CommentRendererReadFragment";
};
export type CommentRendererReadFragment$key = {
  readonly " $data"?: CommentRendererReadFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommentRendererReadFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "css"
  },
  {
    "kind": "ScalarField",
    "name": "data"
  },
  {
    "kind": "ScalarField",
    "name": "js"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "CommentRendererReadFragment",
  "selections": [
    {
      "concreteType": "Macro",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "macroId"
        },
        {
          "kind": "ScalarField",
          "name": "contentId"
        },
        {
          "args": [
            {
              "kind": "Literal",
              "name": "mode",
              "value": "RENDERER"
            }
          ],
          "concreteType": "RenderedMacro",
          "kind": "LinkedField",
          "name": "renderedMacro",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "kind": "ScalarField",
              "name": "macroRenderedRepresentation"
            },
            {
              "kind": "ScalarField",
              "name": "macroBodyStorage"
            },
            {
              "concreteType": "WebResourceDependenciesV2",
              "kind": "LinkedField",
              "name": "webResource",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "contexts"
                },
                {
                  "kind": "ScalarField",
                  "name": "keys"
                },
                {
                  "concreteType": "SuperBatchWebResourcesV2",
                  "kind": "LinkedField",
                  "name": "superbatch",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "metatags"
                    }
                  ]
                },
                {
                  "concreteType": "WebResourceTagsV2",
                  "kind": "LinkedField",
                  "name": "tags",
                  "plural": false,
                  "selections": (v0/*: any*/)
                },
                {
                  "concreteType": "WebResourceUrisV2",
                  "kind": "LinkedField",
                  "name": "uris",
                  "plural": false,
                  "selections": (v0/*: any*/)
                }
              ]
            },
            {
              "concreteType": "EmbeddedMediaTokenV2",
              "kind": "LinkedField",
              "name": "mediaToken",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "token"
                }
              ]
            }
          ],
          "storageKey": "renderedMacro(mode:\"RENDERER\")"
        }
      ]
    },
    {
      "concreteType": "PageInfoV2",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "endCursor"
        },
        {
          "kind": "ScalarField",
          "name": "hasNextPage"
        },
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    }
  ],
  "type": "MacroConnection"
};
})();

(node as any).hash = "2939a86cf744f10a55b9d35c52e07226";

export default node;
